export default "__VITE_ASSET__B$3St2RY__"